import gql from 'graphql-tag';

export default gql`
  {
    currentUser {
      firstName
      lastName
      username
      name
      verified
      hasCompleteBuyerProfile
      imageUrls(configurations: [
        {width: 24, height: 24, quality: 10},
        {width: 24, height: 24},
        {width: 48, height: 48},
        {width: 72, height: 72},
      ])
    }
  }
`;
